import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { IDataTableV2FilterButtonProps } from "./DataTableV2FilterButton.types";

export const DataTableV2FilterButton: React.FC<
  IDataTableV2FilterButtonProps
> = ({ icon, id, label, onClick }) => {
  const IconComponent = icon;

  return (
    <>
      <Button
        variant="contained"
        aria-describedby={"custom-" + id}
        onClick={onClick}
      >
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <IconComponent  sx={{ fontSize: 25 }} />
          <Typography
            variant="body1"
            fontSize={"1.2rem"}
            fontWeight={600}
            
          >
            {label}
          </Typography>
        </Stack>
      </Button>
    </>
  );
};
